import * as React from 'react';
import classNames from 'classnames';
import {getVariantsWithPrefix, camelToHyphen} from '../../utilities';

export type AlignOptions = 'center' | 'left';
export type FractionColumns = 'full' | 'half' | 'third' | 'two_thirds' | 'quarter' | 'three_quarters' | string;

export type MobileNumberColumns = '1' | '2' | '3' | '4';
export type MobileColumns = MobileNumberColumns | FractionColumns;

export type TabletNumberColumns = MobileNumberColumns | '5' | '6';
export type TabletColumns = TabletNumberColumns | FractionColumns;

export type DesktopNumberColumns = TabletNumberColumns | '7' | '8' | '9' | '10' | '11' | '12';
export type DesktopColumns = DesktopNumberColumns | FractionColumns;

const BASE_CLASS = 'grid__item';

type DivProps = JSX.IntrinsicElements['div'];

export interface GridItemProps extends DivProps {
  mobileUp?: MobileColumns;
  mobileUpPull?: MobileColumns;
  mobileUpPush?: MobileColumns;
  mobileUpOffset?: MobileColumns;

  tabletUp?: TabletColumns;
  tabletUpPull?: TabletColumns;
  tabletUpPush?: TabletColumns;
  tabletUpOffset?: TabletColumns;

  desktopUp?: DesktopColumns;
  desktopUpPull?: DesktopColumns;
  desktopUpPush?: DesktopColumns;
  desktopUpOffset?: DesktopColumns;

  mobileUpAlign?: AlignOptions;
  tabletUpAlign?: AlignOptions;
  desktopUpAlign?: AlignOptions;
}

function resolveVariants(prefixVariantMap: any): string[] {
  const snakeCaseMap = Object.keys(prefixVariantMap)
    .filter((prefix) => prefixVariantMap[prefix])
    .reduce((memo, prefix) => {
      memo[camelToHyphen(prefix)] = prefixVariantMap[prefix].replace('_', '-');
      return memo;
    }, {});

  return getVariantsWithPrefix(BASE_CLASS, snakeCaseMap);
}

export function GridItem({
  mobileUp, mobileUpPull, mobileUpPush, mobileUpOffset,
  tabletUp, tabletUpPull, tabletUpPush, tabletUpOffset,
  desktopUp, desktopUpPull, desktopUpPush, desktopUpOffset,
  mobileUpAlign, tabletUpAlign, desktopUpAlign,
  ...restProps
}: GridItemProps) {
  return (
    <div
      {...restProps}
      className={classNames(
        restProps.className,
        BASE_CLASS,
        resolveVariants({
          mobileUp, mobileUpPull, mobileUpPush, mobileUpOffset,
          tabletUp, tabletUpPull, tabletUpPush, tabletUpOffset,
          desktopUp, desktopUpPull, desktopUpPush, desktopUpOffset,
          mobileUpAlign, tabletUpAlign, desktopUpAlign,
        }),
      )}
    />
  );
}

export default GridItem;
